import { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import { Table } from "antd";
import { GlobalFilter } from "../components/table/FilteringTable/GlobalFilter";
import { sortList } from "./Users";
import formatError from "../../services/FormatError";
import { dateFormatter } from "./BuyerProfile";
import {
  fetchAllCurrencies,
  updateCurrencyStatus,
} from "../../services/Currencies";
import { useTranslation } from "react-i18next";
import swal from "sweetalert";


function Currencies() {
    const { t } = useTranslation();

  const role = JSON.parse(sessionStorage.getItem("userDetails"))?.result;

  const [ctData, setCTData] = useState({
    original: [],
    filtered: [],
  });

  const [gridFilter, setGridFilter] = useState("");

  const [tableParams, setTableParams] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  useEffect(() => {
    getAllCurrencies();
  }, []);

  const getAllCurrencies = () => {
    fetchAllCurrencies()
      .then((res) => {
        const response = res?.data?.result;

        const responseData = response ? sortList(response) : [];

        setCTData({
          original: responseData,
          filtered: responseData,
        });

        setTableParams((prevTableParams) => ({
          ...prevTableParams,
          total: response?.length,
        }));
      })
      .catch((error) => {
        formatError(error.response?.data?.error);
      });
  };

  const updateGridFilter = (value) => {
    setGridFilter(value);

    if (value !== "") {
      const updatedFilteredData = ctData.original.filter(
        (item) =>
          item.name.toLowerCase().includes(value.toLowerCase()) ||
          item.code.toLowerCase().includes(value.toLowerCase()) ||
          item.symbol.includes(value)
      );

      setCTData((prevState) => ({
        ...prevState,
        filtered: updatedFilteredData,
      }));
    } else {
      setCTData((prevState) => ({
        ...prevState,
        filtered: prevState.original,
      }));
    }
  };

  const handleTableChange = (pagination) => {
    setTableParams(pagination);
  };

  const onChangeStatus = (id, status) => {
     swal({
          title: t("hconfirm"),
          text: t("hchangestatut"),
          icon: "warning",
          buttons: true,
          dangerMode: true,
        }).then((willdelete) => {
          if(willdelete){
            updateCurrencyStatus(id, status)
              .then((res) => {
                getAllCurrencies();
              })
              .catch((error) => {
                formatError(error.response?.data?.error);
              });
            }
        });
  };

  const columns = [
    {
      title: "S.NO",
      dataIndex: "id",
      sorter: true,
      width: "5%",
      render: (data, obj, index) =>
        tableParams.current
          ? index + 1 + (tableParams.current - 1) * tableParams.pageSize
          : index + 1,
    },
    {
      title: `${t("buyerProfileCulumn2")}`,
      dataIndex: "name",
      sorter: true,
      width: "20%",
    },
    {
      title: `${t("hcode")}`,
      dataIndex: "code",
      sorter: true,
      width: "20%",
    },
    {
      title: `${t("hsymbol")}`,
      dataIndex: "symbol",
      width: "20%",
    },
    {
      title: `${t("businessDetailsCreatedDate")}`,
      dataIndex: "createdat",
      width: "20%",
      render: (text) => dateFormatter(text),
    },
    {
      title: `${t("professionalProfileCulumn7")}`,
      dataIndex: "active",
      render: (status, record) => {
        return (
          <div className="d-flex align-items-center w-100">
            <Form.Check
              type="switch"
              id="custom-switch"
              style={{ marginRight: "8px" }}
              checked={status}
              onChange={() => onChangeStatus(record?.id, status)}
            />
            <span
              class={`badge light ${
                status === true ? "badge-success" : "badge-danger"
              }`}
            >
              {status === true ? "Active" : "Inactive"}
            </span>
          </div>
        );
      },
      width: "20%",
    },
  ];

  return (
    <div class="card">
      <div class="card-header d-sm-flex d-block">
        <div class="me-auto mb-sm-0">
          <h4 class="card-title">{t("sidebarItemCurrencies")}</h4>
        </div>
        <GlobalFilter filter={gridFilter} setFilter={updateGridFilter} />
      </div>

      <div class="card-body">
        <Table
          columns={columns}
          rowKey={(record) => record.id}
          dataSource={ctData.filtered}
          pagination={tableParams}
          onChange={handleTableChange}
        />
      </div>
    </div>
  );
}

export default Currencies;
